import { makeStyles } from "tss-react/mui";

import { Tag } from "@dashboard/shared/components/Tag/Tag";
import { getTagReactKey, sortTags } from "@dashboard/shared/tags";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import type { Row } from "@tanstack/react-table";

import { OtaFile } from "../../types";

const useStyles = makeStyles()((theme) => ({
    tagsCell: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(0.5),
    },
}));

type VersionTableTagsCellProps = {
    row: Row<OtaFile>;
};

export const VersionTableTagsCell = ({ row }: VersionTableTagsCellProps) => {
    const { classes } = useStyles();
    const tags = sortTags(
        Object.entries(row.original.annotation?.metadata?.user ?? {}).map(([key, value]): API.Tag => ({
            key,
            value,
            type: value ? "scoped" : "simple",
        })),
    );

    return (
        <MinimalTableCell>
            <div className={classes.tagsCell}>
                {tags.map((tag) => (
                    <Tag key={getTagReactKey(tag)} item={tag} />
                ))}
            </div>
        </MinimalTableCell>
    );
};
